
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation('partnership');

  const steps = [
    { number: '01', icon: 'ri-file-text-line', title: t('process.steps.0.title'), description: t('process.steps.0.description') },
    { number: '02', icon: 'ri-video-chat-line', title: t('process.steps.1.title'), description: t('process.steps.1.description') },
    { number: '03', icon: 'ri-quill-pen-line', title: t('process.steps.2.title'), description: t('process.steps.2.description') },
    { number: '04', icon: 'ri-rocket-line', title: t('process.steps.4.title'), description: t('process.steps.4.description') },
  ];

  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <span className="text-gold-600 font-semibold text-[10px] md:text-sm uppercase tracking-wider">{t('process.badge')}</span>
          <h2 className="text-lg md:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 md:mt-3 mb-2 md:mb-4 font-serif">
            {t('process.heading')}
          </h2>
          <p className="text-xs md:text-base text-gray-600 max-w-2xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-gray-50 rounded-xl md:rounded-2xl p-3 md:p-8 text-center hover:bg-gold-50 transition-all duration-300 border border-gray-100 hover:border-gold-200 h-full">
                <div className="text-2xl md:text-5xl font-bold text-gold-200 group-hover:text-gold-300 transition-colors mb-1.5 md:mb-4 font-serif">
                  {step.number}
                </div>
                <div className="w-9 h-9 md:w-14 md:h-14 flex items-center justify-center bg-white rounded-lg md:rounded-xl shadow-md mb-2 md:mb-5 mx-auto group-hover:shadow-lg transition-shadow">
                  <i className={`${step.icon} text-sm md:text-2xl text-gold-600`}></i>
                </div>
                <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-1 md:mb-3">{step.title}</h3>
                <p className="text-[10px] md:text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-s-line text-2xl text-gold-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
